import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface ThemesData {
  name: string;
  count: number; // We'll need to adjust the backend to provide counts for each theme
}

// A placeholder function to transform the simple array from the backend
// into something the chart can use. We will adjust the backend later.
const transformData = (themes: string[]): ThemesData[] => {
  return themes.map((theme, index) => ({ name: theme, count: 5 - index })); // Mock count
};

export default function ThemesDisplay({ data }: { data: string[] }) {
  const chartData = transformData(data);

  return (
    <div className="p-4 bg-white rounded-lg shadow">
      <h3 className="text-lg font-semibold text-slate-800 mb-4">Top Coaching Themes</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis dataKey="name" type="category" width={150} />
          <Tooltip />
          <Legend />
          <Bar dataKey="count" fill="#82ca9d" name="Frequency" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
